import {RangeModel} from '../shared/range.model';
import {Enums} from '../../extensions/enums';
import {QuestionExtendedModel} from '../question-extended.model';

export class CountShapesModel extends QuestionExtendedModel {

  model: {
    firstRange: RangeModel,
    shape: string,
    possibleAnswers: RangeModel,
    numAnswers: number
  } = {
    firstRange: new RangeModel(),
    shape: Enums.Shapes.circle,
    possibleAnswers: new RangeModel(),
    numAnswers: 3
  };

  static generateModel(json: any): CountShapesModel {

    const q = new CountShapesModel();

    const model = json.model;

    if (model) {

      if (model.firstRange) {
        q.model.firstRange = RangeModel.generateModel(model.firstRange);
      }

      if (model.possibleAnswers) {
        q.model.possibleAnswers = RangeModel.generateModel(model.possibleAnswers);
      }

      q.model.shape = model.shape;
      q.model.numAnswers = model.numAnswers;

    }

    return q;

  }

}
